// extracted by mini-css-extract-plugin
export default {"selector":"gca","disabled":"hca","hed":"ica","selected":"jca","subHed":"kca","standard":"lca","flavor":"mca","flavorImage":"nca","long":"oca"};
    if(module.hot) {
      // 1730991513071
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  